module.exports = __webpack_public_path__ + "static/011-4c1658e135e7e33c541ccf26e2fb71a1.jpg";